export default {
  bind () {
    var el = this.el
    this.vm.$once('pre-hook:compiled', function () {
      el.removeAttribute('v-cloak')
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue/src/directives/public/cloak.js
// module id = ./node_modules/vue/src/directives/public/cloak.js
// module chunks = 53